module.exports = __webpack_public_path__ + "img/unity-import-rig.0c210946.png";